import {createContext, useCallback, useMemo} from 'react';
import {usePersistedState} from '../../../hooks/usePersistedState';
import stepFiveSchema from '../schema/step-five';
import {stepFourSchema, stepFourSchemaWithGroup} from '../schema/step-four';
import stepEightSchema from '../schema/step-eight';
import stepSevenSchema from '../schema/step-seven';
import stepSixSchema from '../schema/step-six';
import stepThreeSchema from '../schema/step-three';
import stepTwoSchema from '../schema/step-two';

const initialState = {
  flow: 'student',
  ref: '',
  experience: {
    flow: null,
    items: [
      {
        flow: null,
        firm: null,
        position: null,
        acceptedFullTime: false,
      }
    ],
  },
  education: [{
    degree: 'undergraduate',
    school: null,
    major: null,
    graduationYear: null,
  }],
  testScore: {
    enabled: [],
  },
  location: {
    sendJobs: true,
  },
  leadership: {
    discloseMilitary: 'prefer_not_to_say',
    athlete: 'No',
  },
  workStatus: {
    discloseGender: 'prefer_not_to_say',
    discloseRace: 'prefer_not_to_say',
    discloseLgbtq: 'prefer_not_to_say',
  },
  resume: {},
};

const SignupContext = createContext(initialState);

const SignupContextProvider = ({children}) => {
  const [state, setState] = usePersistedState('signup-state', initialState);
  const validationSchemas = useMemo(() => ({
    education: stepTwoSchema,
    testScore: stepThreeSchema,
    experience: stepFourSchema,
    experienceWithGroup: stepFourSchemaWithGroup,
    location: stepFiveSchema,
    workStatus: stepSixSchema,
    leadership: stepSevenSchema,
    resume: stepEightSchema,
  }), []);

  const validate = useCallback(async (key) => {
    const schema = validationSchemas[key];

    if (!schema) {
      return Promise.resolve(true);
    }
  }, [validationSchemas]);

  const resetState = useCallback((hard = false) => {
    setState((current) => ({
      ...initialState,
      flow: hard ? '' : current.flow,
      ref: hard ? '' : current.ref,
      experience: hard ? {
        ...initialState.experience,
        flow: ['experienced-professional', 'student'].includes(current.flow) ? current.flow : null
      } : {
        ...current.experience,
        flow: ['experienced-professional', 'student'].includes(current.flow) ? current.flow : null
      }
    }));
  }, [setState]);

  return (
    <SignupContext.Provider value={{state, setState, resetState}}>
      {children}
    </SignupContext.Provider>
  );
};

export {SignupContext, SignupContextProvider};
